import { mapState } from 'vuex';
export default {
  name: 'TimeInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    // value in seconds
    label: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      timeValue: 1,
      timeUnit: 'minutes',
      unitOptions: [{
        text: this.$i18n_t('Connectors.Monitoring.rules.units.minutes'),
        value: 'minutes'
      }, {
        text: this.$i18n_t('Connectors.Monitoring.rules.units.hours'),
        value: 'hours'
      }, {
        text: this.$i18n_t('Connectors.Monitoring.rules.units.days'),
        value: 'days'
      }, {
        text: this.$i18n_t('Connectors.Monitoring.rules.units.weeks'),
        value: 'weeks'
      }]
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    outlined() {
      return this.inpOutlined;
    },
    filled() {
      return this.inpFilled;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parseSeconds(newValue);
        }
      }
    }
  },
  methods: {
    parseSeconds(seconds) {
      // convert seconds to most appropriate unit
      if (seconds % (7 * 24 * 3600) === 0 && seconds >= 7 * 24 * 3600) {
        this.timeValue = seconds / (7 * 24 * 3600);
        this.timeUnit = 'weeks';
      } else if (seconds % (24 * 3600) === 0 && seconds >= 24 * 3600) {
        this.timeValue = seconds / (24 * 3600);
        this.timeUnit = 'days';
      } else if (seconds % 3600 === 0 && seconds >= 3600) {
        this.timeValue = seconds / 3600;
        this.timeUnit = 'hours';
      } else {
        this.timeValue = Math.max(1, Math.round(seconds / 60)); // minimum 1 minute
        this.timeUnit = 'minutes';
      }
    },
    convertToSeconds() {
      const value = parseInt(this.timeValue, 10) || 1;
      switch (this.timeUnit) {
        case 'weeks':
          return value * 7 * 24 * 3600;
        case 'days':
          return value * 24 * 3600;
        case 'hours':
          return value * 3600;
        case 'minutes':
        default:
          return value * 60;
      }
    },
    handleValueChange(newValue) {
      this.timeValue = Math.max(1, parseInt(newValue, 10) || 1);
      this.emitChange();
    },
    handleUnitChange(newUnit) {
      this.timeUnit = newUnit;
      this.emitChange();
    },
    emitChange() {
      const seconds = this.convertToSeconds();
      this.$emit('input', seconds);
    }
  }
};